import React, { Component } from "react";
import { Redirect, Link } from 'react-router-dom';
import ReactFullpage from '@fullpage/react-fullpage';
import styles from '../assets/scss/modules/kampany.module.scss';
import twitter from "../assets/media/images/Twitter.png";
import tiktok from "../assets/media/images/Tiktok.png";
import instagram from "../assets/media/images/Instagram.png";
import facebook from "../assets/media/images/Facebook.png";
import jogasz from "../assets/media/images/jogasz.png";
import kepviselo from "../assets/media/images/kepviselo.png";
import csalad from "../assets/media/images/csalad.png";
import asset1 from "../assets/media/images/asset1.png";
import asset2 from "../assets/media/images/asset2.png";
import asset3 from "../assets/media/images/asset3.png";
import asset4 from "../assets/media/images/asset4.png";
import asset5 from "../assets/media/images/Titles/meltoIdoskort.png";
import asset6 from "../assets/media/images/asset6.png";
import back_btn from "../assets/media/newicons/back.png";
import back_btn_black from "../assets/media/newicons/back-black.png";
import forward_btn_black from "../assets/media/newicons/nextBlue.png";
import forward_btn from "../assets/media/newicons/forward.png";
import erikfoto from "../assets/media/images/Erik-foto.png";
import konczer_facebook from "../assets/media/images/konczer-facebook.png";
import gradiensProgram from "../assets/media/images/gradiensProgram.png";
import Footer from "../components/Footer/Footer";
import FooterResponziv from "../components/Footer/FooterResponziv";
import BackComponent from "../components/Kiegeszitok/BackComponent";
import BackComponentRespo from "../components/Kiegeszitok/BackComponentRespo";
import NavbarComponent from "../NavbarComponent";
import { Scrollbar } from "react-scrollbars-custom";



import{
	MDBContainer,
  MDBScrollbar,
	MDBRow,
	MDBCol,
	MDBCard,
	MDBCardHeader,
	MDBCardBody,
  MDBBtn,
} from 'mdbreact';

class MeltoIdoskor extends Component {

	constructor(props) {
    super(props);
    this.state = {navbarPaddingTop: true,
									};
  };

	componentDidMount() {
		document.addEventListener("scroll", this.scrollEventListener);
	}

	componentWillUnmount() {
	}

	scrollEventListener = (event) => {
		const navPadding = window.scrollY < 100 ? true : false;
		this.setState({ navbarPaddingTop: navPadding});
	}


  render() {
		const anchors = ["program1", "program2", "program3"];
    return (
			<>
<MDBContainer fluid className="fluid-container">
	<div className="d-none d-lg-block">
		<div className={styles.bodywrapper}>
			<BackComponent text={"MindannyiunkHangja"} text2={"Mindannyiunk hangja"} program={"program9"}/>
			<MDBContainer fluid className="program-container-programok">
				<Scrollbar
									id="scrollbar"
									style={{ width: "100%", height: "76vh", marginTop: "-5vh"}}
									maximalThumbYSize = {50}
									noScrollX = {true}
				>
					<MDBContainer fluid className="section" id="program">
						<div className={styles.bodywrapper3}>
							<MDBRow  center className="program-text-row-start">
							</MDBRow>
							<MDBRow  center>
								<div className="embed-responsive embed-responsive-16by9 videoformat">
									<iframe className="embed-responsive-item" src={"https://www.youtube.com/embed/Zl9xD21N0mo"} allowFullScreen autoPlay></iframe>
								</div>
							</MDBRow>
							<MDBRow  center className="program-text-row">
								<p className="a-megyei-kozgyulesbe">Az elmúlt 12 év világosan megmutatta, hogy az Orbán-kormány hogyan tekint a
								nyugdíjasokra. Előbb megszüntette a svájci indexálást, az inflációszámításnál eltörölte a nyugdíjas
								vásárlói kosarat, ezzel elértéktelenítve a nyugdíjakat. Tatabányán és környékén is egyre többeknek
								okoz problémát a lakás fűtése, és a szépkorúakat az elszabadult élelmiszerárak miatt nap mint nap
								fenyegeti az elszegényedés réme. Pedig a nyugdíjasoknak nem könyöradományokra és választási
								ajándékokra van szükségük, hanem kiszámítható, méltó időskorra! A rugalmas nyugdíjbavonulás és az
								öregségi nyugdíjminimumot megduplázó nyugdíjkorrekciós program mellett helyi támogató rendszert
								vezetünk be a bajban lévőknek: megduplázzuk a kivételes nyugellátás, a kivételes nyugdíj
								megállapítás, valamint az egyszeri segély éves keretét! Nem hagyjuk leszakadni a nyugdíjakat
								a bérektől és megtartjuk a 13. havi juttatást!</p>
							</MDBRow>
							<MDBRow  center className="program-text-row-end">
								<p className="a-megyei-kozgyulesbe">Az idősek társadalmi megbecsülését nem lehet és nem is
								fogjuk csupán nyugdíjkérdésként kezelni. A létbiztonság megteremtése a legsürgetőbb, de biztosítani
								fogjuk a hozzáférhető és megfelelő szintű ápolást, egészségügyi ellátást számukra. Az Idősek jóllétének
								alapja az aktív időskor megélése, ezért biztosítani kell a kulturális és közösségi szolgáltatásokat,
								valamint az időskori tanulás lehetőségeihez való széleskörű hozzáférést. Szélesítjük a tatabányai
								és tatai idősklubok lehetőségeit, támogatjuk azok működését!</p>
							</MDBRow>

						</div>
				</MDBContainer>

			</Scrollbar>
		</MDBContainer>

		<div className="fixed-bottom d-none d-lg-block">
		<div className="gradient"/>
			<Footer/>
		</div>
	</div>
	</div>
</MDBContainer>

<div className="d-block d-lg-none">
	<MDBContainer fluid className="fluid-container">
		<div className={styles.bodywrapper2}>
			<BackComponentRespo navbarPaddingTop={this.state.navbarPaddingTop} text={"MindannyiunkHangja"} program={"program9"}/>
		</div>
		<div className={styles.bodywrapper3}>
			<img className="asset5-respo" src={asset5}></img>
			<MDBRow  center className="program-text-row-start m-0 px-3">
				<p className="jelenleg-is-ont-kepv"></p>
				<div className="embed-responsive embed-responsive-16by9 videoformat">
					<iframe className="embed-responsive-item" src={"https://www.youtube.com/embed/Zl9xD21N0mo"} allowFullScreen autoPlay></iframe>
				</div>
				<p className="a-megyei-kozgyulesbe">Az elmúlt 12 év világosan megmutatta, hogy az Orbán-kormány hogyan tekint a
				nyugdíjasokra. Előbb megszüntette a svájci indexálást, az inflációszámításnál eltörölte a nyugdíjas
				vásárlói kosarat, ezzel elértéktelenítve a nyugdíjakat. Tatabányán és környékén is egyre többeknek
				okoz problémát a lakás fűtése, és a szépkorúakat az elszabadult élelmiszerárak miatt nap mint nap
				fenyegeti az elszegényedés réme. Pedig a nyugdíjasoknak nem könyöradományokra és választási
				ajándékokra van szükségük, hanem kiszámítható, méltó időskorra! A rugalmas nyugdíjbavonulás és az
				öregségi nyugdíjminimumot megduplázó nyugdíjkorrekciós program mellett helyi támogató rendszert
				vezetünk be a bajban lévőknek: megduplázzuk a kivételes nyugellátás, a kivételes nyugdíj
				megállapítás, valamint az egyszeri segély éves keretét! Nem hagyjuk leszakadni a nyugdíjakat
				a bérektől és megtartjuk a 13. havi juttatást!</p>
			</MDBRow>
			<MDBRow  center className="program-text-row-end m-0 px-3">
				<p className="a-megyei-kozgyulesbe">Az idősek társadalmi megbecsülését nem lehet és nem is
				fogjuk csupán nyugdíjkérdésként kezelni. A létbiztonság megteremtése a legsürgetőbb, de biztosítani
				fogjuk a hozzáférhető és megfelelő szintű ápolást, egészségügyi ellátást számukra. Az Idősek jóllétének
				alapja az aktív időskor megélése, ezért biztosítani kell a kulturális és közösségi szolgáltatásokat,
				valamint az időskori tanulás lehetőségeihez való széleskörű hozzáférést. Szélesítjük a tatabányai
				és tatai idősklubok lehetőségeit, támogatjuk azok működését!</p>
			</MDBRow>
		</div>
	</MDBContainer>
	<MDBContainer fluid className="fluid-container">
		<div className={styles.bodywrapper5}>
			<FooterResponziv/>
		</div>
	</MDBContainer>
</div>
</>
    );
  }
}
export default  MeltoIdoskor;
